import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { RFQAmail } from "@tSchaedlerYesco/Services/RequestUsService";

type SubmitContactFormParameter = {
    type: string;
    fullName: string;
    companyName: string;
    city: string;
    state: string;
    email: string;
    phoneNumber: string;
    preferredCommunicationMethod: any;
    notes: string;
    products: any;
    additionalRequestedProduct: any;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactFormParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;

    props.apiParameter = {
        type: props.parameter.type,
        fullName: props.parameter.fullName,
        companyName: props.parameter.companyName,
        city: props.parameter.city,
        state: props.parameter.state,
        email: props.parameter.email,
        phoneNumber: props.parameter.phoneNumber,
        preferredCommunicationMethod: props.parameter.preferredCommunicationMethod,
        notes: props.parameter.notes,
        products: props.parameter.products,
        additionalRequestedProduct: props.parameter.additionalRequestedProduct,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await RFQAmail(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitRFQAForm = createHandlerChainRunner(chain, "submitRFQAForm");
export default submitRFQAForm;
